export var handleKeyDown = function(onContinue) {
    return function(event) {
        var keyCode = event.keyCode || event.key;
        if ((keyCode === 13 || keyCode === "Enter") && !event.repeat) {
            event.preventDefault();
            onContinue();
        }
    };
};
